export const getTicketPurchaseDestination = (eventId, eventStatus) => {
  const normalizedStatus = String(eventStatus || "").trim().toLowerCase();
  if (eventId && normalizedStatus === "live") {
    return `/event/${encodeURIComponent(eventId)}?watch=1`;
  }
  return "/my-tickets";
};
